import socket from "./socket";
// import { widget  } from '../../../public/static/charting_library/charting_library.min';

import store from '@/store/index'
import actions from "@/store/index";
import datafeeds from './datafees';
import { getOverrides, getStudiesOverrides } from '@/utils/overrides';
import {klineHis} from '@/api/wiki'
import { digits2 } from "@/utils/baseFn/filter";
class TVjsApi {
  constructor() {
    this.symbol = store.state.symbol;
    this.pricescale = 5; //每个交易对的精度
    // this.pricescale = store.state.tickSize; //每个交易对的精度
    this.urls = '';
    this.resetTime=true
    this.widgets = null; //tradingview图表
    this.socket = new socket(store.state.country);
    this.interval = localStorage.getItem('tradingview.resolution') || '15'; //图表周期
    this.cacheData = {}; //图表缓存数据
    this.resolveSymbolinfo = {}; //交易对信息
    this.lastTime = null;
    this.endDate = null
    this.isFirst=true
    this.getBarTimer = null;
    this.studies = []; //配置项
    this.isLoading = true; //是否懒加载
    this.socket.doOpen();
    this.socket.on('message', this.onMessage.bind(this));
    this.socket.on('close', this.onClose.bind(this));
    this.socket.on('error', this.onError.bind(this));
    this.datafeeds = new datafeeds(this);
    this.initMessage 

    
    // 
  }
  /**
   * @description 图表初始化
   */
  init(local) {
    // this.styles = options.styles;  // 样式

    let resolution = this.interval; //图表周期
    let symbol = this.symbol; //交易对信息
    // .toLocaleUpperCase()
    // let locale = 'zh'; //中文本地化
    let skin = store.state.theme || 'dark'; //皮肤
    if (!this.widgets) {
        this.widgets = new window.TradingView.widget({
        autosize: true,
        symbol: symbol,
        interval: resolution,
        container_id: 'tv_chart_container',
        datafeed: this.datafeeds,
        library_path: '/static/charting_library/',
        timezone: 'Asia/Shanghai',
        locale: local, // 国际化
        custom_css_url: 'chart.css',
        // toolbar_bg: "transparent",
        toolbar_bg: skin==='dark'?'#0E1D2C':'#fff',
        loading_screen: { backgrounddivor: "#0E1D2C" },
      //   time_scale: {
      //     min_bar_spacing: 10,
      // },
        // ...theme0Config,
        debug: false,
        disabled_features: [ //禁用插件
          
         "border_around_the_chart",
         "compare_symbol",
        "display_market_status",
        "go_to_date",
        "header_widget",
        "header_chart_type",
        "header_compare",
        "header_interval_dialog_button",
        "header_resolutions",
        "header_screenshot",
        "header_symbol_search",
        "header_undo_redo",
        "header_saveload",
        "legend_context_menu",
        "show_hide_button_in_legend",
        "show_interval_dialog_on_key_press",
        "snapshot_trading_drawings",
        "symbol_info",
        'main_series_scale_menu',
        "timeframes_toolbar",
        // "use_localstorage_for_settings",
        "volume_force_overlay",
    "legend_widget",// 禁用此功能会隐藏图例窗口小部件
    
        ],
        enabled_features: [ //启用插件
          "study_templates",
          "hide_left_toolbar_by_default", // 第一次打开时隐藏左边工具栏
          "dont_show_boolean_study_arguments",
          "use_localstorage_for_settings", // 允许将用户设置保存到localstorge
          "hide_last_na_study_output",
          "move_logo_to_main_pane",
          "same_data_requery",
          "side_toolbar_in_fullscreen_mode",
          "disable_resolution_rebuild",
          "keep_left_toolbar_visible_on_small_screens",
          "layout_about_to_be_changed",
        ],
        customFormatters: {
          timeFormatter: {
            format: function (date) {
            
              const _format_str = "%h:%m";
              let h = date.getUTCHours();
              if (h < 10) {
                h = "0" + h;
              }
              let m = date.getUTCMinutes();
              if (m < 10) {
                m = "0" + m;
              }
              let s = date.getUTCSeconds();
              if (s < 10) {
                s = "0" + s;
              }
                return _format_str
                  .replace("%h", h, 2)
                  .replace("%m", m, 2)
                  .replace("%s", s, 2);
            },
          },
          dateFormatter: {
            format: function (date) {
            
              return (
                date.getUTCFullYear() +
                "/" +
                (date.getUTCMonth() + 1) +
                "/" +
                date.getUTCDate()
              );
            },
          },
        },
        studies_overrides: getStudiesOverrides(skin),
        overrides: getOverrides(skin),
      });
      let thats = this.widgets;

      // thats.headerReady().then(() => {
      //   // this.createButton(buttons); //生成时间按钮
      // });
      thats.onChartReady(() => {
    let thats = this.widgets;
        let c = ["#397d51", "#5c7798", "#821f68"];
        let n = [30, 10, 5];
        n.forEach((item, i) => {
          try {
            thats.chart().createStudy("Moving Average Exponential", false, false, [item], null, {
              "plot.color": c[i],
              precision: 8, //this.symbol.baseAssetPrecision
            });
          } catch (e) {
            console.log(e);
          }
        });
    
        // thats.chart().createStudy("volume");
      });

    }
  }
  /**
   * @description 创建5、10、30日均线
   */
  createStudy() {
    let thats = this.widgets;
    let id = thats.chart().createStudy('Moving Average', false, false, [5], null, { 'Plot.color': '#821f68' ,precision:8});
    this.studies.push(id);
    id = thats.chart().createStudy('Moving Average', false, false, [10], null, { 'Plot.color': '#5c7798' ,precision:8});
    this.studies.push(id);
    id = thats.chart().createStudy('Moving Average', false, false, [30], null, { "plot.color": "#397d51",precision:8 });
    this.studies.push(id);
  }

  /**
   * @description 生成周期按钮
   */
  createButton(buttons) {
    let widget = this.widgets;
    let allresolution = [];
    let self = this;
    for (let index = 0; index < buttons.length; index++) {
      let button = widget.createButton();
      button.textContent = buttons[index].title;
      button.setAttribute('data-resolution', buttons[index].resolution);
      let directlyparent = button.parentNode.parentNode;
      directlyparent.className += ' Kline-resolutionparent';
      directlyparent.setAttribute('data-resolution', buttons[index].resolution);
      if (buttons[index].resolution == this.interval) {
        directlyparent.className += ' cur';
      }
      allresolution.push(directlyparent);
      button.addEventListener('click', function () {
        let state = true;
        Object.keys(self.cacheData).forEach((item) => {
          if (item.indexOf('state') > -1) {
            if (!self.cacheData[item]) {
              state = !state;
            }
          }
        });
        if (!state) {
          let selectedresolution = this.getAttribute('data-resolution');
          if (self.interval == selectedresolution) {
            return;
          }
          self.isLoading = true;
          self.interval = selectedresolution;
          localStorage.setItem('tradingview.resolution', selectedresolution);
          for (let i = 0; i < allresolution.length; i++) {
            let element = allresolution[i];
            let eleresolution = element.getAttribute('data-resolution');
            if (eleresolution == self.interval) {
              element.className += ' cur';
            } else {
              if (element.className.includes('cur')) {
                let classarr = element.className.split(' ');
                classarr.pop();
                element.className = classarr.join(" ");
              }
            }
          }
          widget.chart().setResolution(self.interval, function () {
            self.isLoading = false;
          });
        }
      });
    }
    //创建指标
    let indicatorbutton = widget.createButton();
    indicatorbutton.textContent = '指标';
    indicatorbutton.className += ' indicator';
    indicatorbutton.addEventListener('click', function () {
      widget.chart().executeActionById("insertIndicator");
    });
  }
  setSymbol(market, resolution, callBack) {
    this.widgets.setSymbol(market, resolution, callBack);
    this.resetTime=true
    this.isFirst=true
  }
  takeClientScreenshot(){
    let options ={
      backgroundColor:'#ffffff',
      borderColor:'#ffffff'
    }
    // this.widgets._innerAPI.takeClientScreenshot(options);
  }
  changeTheme(){
    // this.widgets.changeTheme('Dark')
  }
  // 全屏方法
  showFullScreen() {
    this.widgets._innerAPI()._chartWidgetCollection.startFullscreen();
  }
  // 关闭全屏
  hideFullScreen() {
    this.widgets._innerAPI()._chartWidgetCollection.exitFullscreen();
  }
  // 显示确认对话框
  showConfirmDialog() {
    this.widgets.showConfirmDialog();
  }
  // 显示加载对话框
  showLoadChartDialog() {
    this.widgets.showLoadChartDialog();
  }
  // 显示通知对话框
  showNoticeDialog() {
    this.widgets.showNoticeDialog();
  }
  // 显示保存对话框
  showSaveAsChartDialog() {
    this.widgets.showSaveAsChartDialog();
  }
  // 设置语言
  setLanguage(lang) {
    this.widgets.setLanguage(lang);
  }

  // 设置分辨率
  setResolution(r) {
    this.widgets._innerAPI()._chartWidgetCollection.setResolution(r);
  }
  changeChatType(type) {
    this.widgets.applyOverrides({
      'mainSeriesProperties.style': type
    });
  }
  chartSetResolution(r) {
    this.resetTime=true
      this.widgets.chart().setResolution(r, () => {
      }); 
    this.isFirst=true
      
  }
  executeActionById(actionId) {
    // chartProperties      图表属性
    // compareOrAdd         比较或添加
    // scalesProperties     比例属性
    // tmzProperties        时区
    // paneObjectTree       窗格对象树
    // insertIndicator      插入指标
    // symbolSearch         符号搜索
    // changeInterval       改变间隔
    // timeScaleReset       时间比例重置
    // drawingToolbarAction 绘图工具栏
    this.widgets.chart().executeActionById(actionId);
  }

  /**
   * @description websocket推送信息
   * @param {Object} e
   */
  onMessage(e) {
    if(e.type==='getBars'){
      // this.disabled = true;
      let data = e.data;
      const ticker = `${this.symbol}-${this.interval}`; //APPLE/CNY-15
      const tickerCallback = ticker + "Callback"; //APPLE/CNY-15Callback
      if (data && data.length) {
        // 过滤后端数据为null的字段
        data = data.filter(e => e.indexOf(null) < 0)
        let list = [];
        const tickerstate = ticker + "state"; //APPLE/CNY-15state
        const onLoadedCallback = this.cacheData[tickerCallback];
        list = this.getCacheDataTicker(data);
        this.endDate=list[0].time  // 获取历史数据的开始时间作为下次获取历史数据的结束时间
        //如果没有缓存数据，则直接填充，发起订阅
        if (!this.cacheData[ticker]) {
          this.cacheData[ticker] = list;
          this.subscribe(); //发起订阅
        }
        //新数据即当前时间段需要的数据，直接喂给图表插件
        if (onLoadedCallback) {
          onLoadedCallback(list, { noData: false });
          delete this.cacheData[tickerCallback];
        }
        //请求完成，设置状态为false
        this.cacheData[tickerstate] = !1;
        //记录当前缓存时间，即数组最后一位的时间
        this.lastTime = this.cacheData[ticker][this.cacheData[ticker].length - 1].time
        
      } else {
        const onLoadedCallback = this.cacheData[tickerCallback];
        const tickerstate = ticker + "state"; //APPLE/CNY-15state
        //请求完成，设置状态为false
        this.cacheData[tickerstate] = !1;
        if (onLoadedCallback) {
          onLoadedCallback([], { noData: true });
          delete this.cacheData[tickerCallback];
        }
      }
      
    }
    else{
      if(this.resetTime){
        this.widgets.chart().executeActionById("timeScaleReset");
        this.resetTime=false
      }
      let data = e.data.k;
      if (data) {
        const ticker = `${this.symbol}-${this.interval}`; //APPLE/CNY-1d
        let barsData = {
          time: data.t,
          open:Number(digits2(data.o,8)) ,
          high: Number(digits2(data.h,8)) ,
          low: Number(digits2(data.l,8)) ,
          close: Number(digits2(data.c,8)) ,
          volume: Number(data.v),
        }
       
        //如果增量更新数据的时间大于缓存时间，而且缓存有数据
        if (barsData.time > this.lastTime && this.cacheData[ticker] && this.cacheData[ticker].length) {

          //增量更新的数据直接加入缓存数组
          this.cacheData[ticker].push(barsData);
          //修改缓存时间
          this.lastTime = barsData.time;
          //通知图表插件，可以开始增量更新的渲染了
          // this.widgets.activeChart().resetData();
          this.datafeeds.barsUpdater.updateData();
        } else if (barsData.time == this.lastTime && this.cacheData[ticker] && this.cacheData[ticker].length) {
          //如果增量更新的时间等于缓存时间，即在当前时间颗粒内产生了新数据，更新当前数据
          this.cacheData[ticker][this.cacheData[ticker].length - 1] = barsData;
          //通知图表插件，可以开始增量更新的渲染了
          this.datafeeds.barsUpdater.updateData();
          
        }
        
      }

    }
  }
  getCacheDataTicker(list) {
    const cannotwritable = ["1D", "1W", "1M"];
    let addtime = 86400000;
    return list.map((item) => {
      let newItem = {
        time: item[0],
        
        open:Number(item[1],8),
        high: Number(item[2],8),
        low: Number(item[3],8),
        close: Number(item[4],8),
        volume: Number(item[5]),
      };
      if (cannotwritable.includes(this.interval)) {
        if (this.interval == '1D') {
          newItem.time += addtime;
        }
        if (this.interval == '1W') {
          newItem.time += (addtime * 7);
        }
        if (this.interval == '1M') {
          newItem.time = this.getNextMonth(newItem.time);
        }
      }
      return newItem;
    });
  }
  /**
   * @description 当前日期下一月
   */
  getNextMonth(date) {
    let timestr = new Date(date);
    let year = timestr.getUTCFullYear();
    let month = timestr.getUTCMonth();
    let day = timestr.getUTCDate();
    // eslint-disable-next-line no-unused-vars
    let days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中的月的天数
    let year2 = year;
    let month2 = parseInt(month) + 1;
    if (month2 == 13) {
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }
    let day2 = day;
    let days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
      day2 = days2;
    }
    if (month2 < 10) {
      month2 = '0' + month2;
    }
    // let t2 = year2 + '-' + month2 + '-' + day2;
    let nextmonth = new Date(year2, month2, day2, 0, 0, 0).getTime();
    return nextmonth;
  }
  /**
   * @description websocket关闭信息
   */
  onClose() {
    console.log('tradingview index.js >> : 连接已断开... 正在重连')
    // this.socket.destroy();
    this.socket.doOpen();
    this.socket.on('open', () => {
      console.log(' >> : 已重连')
      this.subscribe();
    });
  }
  /**
   * @description websocket错误信息
   */
   onError() {
    console.log('WebSocket连接发生错误----')
    this.socket.doOpen();
    this.socket.on('open', () => {
      console.log(' >> : 已重连')
      this.subscribe();
    });
  }
 
  /**
   * 发送websocket消息
   * @param {Object} data
   */
  sendMessage(data) {
      actions.dispatch('setIsShow',{isShow:true})
    if (this.socket.checkOpen()) { //检验websocket是否打开
      this.socket.send(data);
    } else {
      this.socket.send(data);
      this.socket.on('open', () => {
        this.socket.send(data);
      });
    }
  }
  /**
   * @description 获取历史K线数据
   * @param {*} symbolInfo
   * @param {*} resolution
   * @param {*} rangeStartDate
   * @param {*} rangeEndDate
   * @param {*} onLoadedCallback
   */
  getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, onLoadedCallback) {
    let ticker = `${symbolInfo.name}-${resolution}`;
    let tickerload = ticker + "load";
    let tickerstate = ticker + "state";
    // console.log(rangeStartDate,rangeEndDate);
    if (!this.cacheData[ticker] && !this.cacheData[tickerstate]) { //如果缓存没有数据，而且未发出请求，记录当前节点开始时间
      this.cacheData[tickerload] = rangeStartDate;
      //发起请求，从websocket获取当前时间段的数据
      this.initMessage(symbolInfo, resolution, rangeStartDate, rangeEndDate, onLoadedCallback);
      //设置状态为true
      this.cacheData[tickerstate] = true;
      return false;
    }
    // 获取历史记录
    if (!this.cacheData[tickerload] || this.cacheData[tickerload] > rangeStartDate) { //如果缓存有数据，但是没有当前时间段的数据，更新当前节点时间
      // if((this.endDate/1000) > rangeStartDate){
      this.isFirst=false
      this.cacheData[tickerload] = rangeStartDate;
      // console.log(rangeStartDate,rangeEndDate);
      // 1296055   this.endDate
      let end=(this.endDate-(rangeEndDate*1000))/1000 +rangeEndDate
      let start= (this.endDate-(rangeEndDate*1000))/1000+rangeStartDate
      this.initMessage(symbolInfo, resolution, start, end, onLoadedCallback);
      // this.initMessage(symbolInfo, resolution, rangeStartDate, rangeEndDate, onLoadedCallback);
      //设置状态为true
      this.cacheData[tickerstate] = true;
      return false;
    }
    // console.log(`开始订阅时状态：${this.cacheData[tickerstate]}`);
    if (this.cacheData[tickerstate]) { //正在从websocket获取数据，禁止一切操作
      // return false;
    }
    ticker = `${symbolInfo.name}-${this.interval}`;
    // 如果缓存中有当前时间段的数据，构造newBars，调用onLoadedCallback(newBars)。
    if (this.cacheData[ticker] && this.cacheData[ticker].length) {
      this.isLoading = false; //关闭loading
      const newBars = [];
      this.cacheData[ticker].forEach(item => {
        // if (item.time >= rangeStartDate * 1000 && item.time <= rangeEndDate * 1000) {
        if (item.time >= rangeStartDate * 1000) {
          newBars.push(item);
        }
      });
      onLoadedCallback(newBars);
      
    } else {
      this.getBarTimer = setTimeout(() => {
        this.getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, onLoadedCallback)
      }, 5000);
    }
  }
  /**
   * @description 初始化数据
   * @param {*} symbolInfo
   * @param {*} resolution
   * @param {*} rangeStartDate
   * @param {*} rangeEndDate
   * @param {*} onLoadedCallback
   */
  initMessage(symbolInfo, resolution, rangeStartDate, rangeEndDate, onLoadedCallback) {
    //保留当前回调
    
    //   this.datafeeds.reset(symbolInfo);
    // this.datafeeds.getonResetCacheNeededCallback();
    const tickerCallback = symbolInfo.name + "-" + resolution + "Callback";
    this.cacheData[tickerCallback] = onLoadedCallback;
    //如果当前时间节点已经改变，停止上一个时间节点的订阅，修改时间节点值
    if (this.interval !== resolution) {
      this.unSubscribe(this.interval)
      this.interval = resolution;
    }
    
    //获取当前时间段的数据，在onMessage中执行回调onLoadedCallback
    // 
    if (symbolInfo && resolution&& rangeStartDate && rangeEndDate) {
      let symbol = symbolInfo.full_name;
      let resolutionstr = this.initresolutionstr(resolution);
      
      let country=store.state.country
      //获取接口数据，然后再从sokect中获取数据
      // Math.ceil((to - from) / (this.resolution * 60 * 1000)) : ""
      let limit=500
      if(!this.isFirst){
        
         limit=Math.ceil((rangeEndDate*1000 - rangeStartDate*1000) / (resolution * 60*1000 ))
      }else{
        limit=500
      }
        let params = {
          symbol:symbol.toUpperCase(),
          interval: resolutionstr,
          limit:limit,
          startTime:rangeStartDate*1000,
          endTime:rangeEndDate*1000,
          isFirst:this.isFirst
        }
        klineHis(params,country).then((res) => {
          if (res && res.length) {
            
            this.onMessage({
              type: 'getBars',
              data: res,
              // endTime: rangeEndDate * 1000,
            });
            
          } else {
            this.onMessage({
              type: 'getBars',
              data: [],
            });
          }
        }).catch((err) => {
          console.log(err);
        });
      
    }
  }
  initresolutionstr(resolution) {
    // let resolutionstr=resolution+'m'
    let resolutionstr = '';
    if (resolution < 60) {
      resolutionstr = resolution + 'm';
    } else if (resolution == '60') {
      resolutionstr = '1h';
    }  else if (resolution == '120') {
      resolutionstr = '2h';
    } else if (resolution == '240') {
      resolutionstr = '4h';
    } else if (resolution == '360') {
      resolutionstr = '6h';
    } else if (resolution == '720') {
      resolutionstr = '12h';
    } else if (resolution == '1440') {
      resolutionstr = '1d';
    } else if (resolution == '10080') {
      resolutionstr = '1w';
    } else if (resolution == '44640') {
      resolutionstr = '1M';
    }
    return resolutionstr

    // return resolutionstr;
  }
  /**
   * @description 发起订阅
   */
  subscribe() {
    let resolutionstr = this.initresolutionstr(this.interval);
    let params = {
      id:2,
      method: "SUBSCRIBE",
      params:[ `${this.symbol}@kline_${resolutionstr}`]
    }
    this.sendMessage(JSON.stringify(params));
  }
  /**
   * @s 取消订阅
   * @param {String} interval 周期
   */
  unSubscribe(interval) {
    // 停止订阅，删除过期缓存、缓存时间、缓存状态

    const ticker = `${this.symbol}-${interval}`;
    const tickertime = ticker + "load";
    const tickerstate = ticker + "state";
    const tickerCallback = ticker + "Callback";
    delete this.cacheData[ticker];
    delete this.cacheData[tickertime];
    delete this.cacheData[tickerstate];
    delete this.cacheData[tickerCallback];
    // let resolutionstr = this.initresolutionstr(this.interval);
    let resolutionstr = this.initresolutionstr(interval);
    
    let params = {
      id:2,
      method: "UNSUBSCRIBE",
      params:[ `${this.symbol}@kline_${resolutionstr}`]

      // value: `market.${this.symbol}.kline.${resolutionstr}`

    }
 
    this.sendMessage(JSON.stringify(params));
  }
  
  /**
   * @description 切换交易对
   * @param {String} newpair 新交易对
   * @param {String} oldpair 旧交易对
   */
  switchtranspair(newpair, oldpair) {
    // 旧交易对 停止订阅，删除过期缓存、缓存时间、缓存状态
    const oldticker = `${oldpair}-${this.interval}`;
    this.datafeeds.unsubscribeBars(oldticker); //取消订阅
    // this.symbol=newpair
    const tickertime = oldticker + "load";
    const tickerstate = oldticker + "state";
    const tickerCallback = oldticker + "Callback";
    delete this.cacheData[oldticker];
    delete this.cacheData[tickertime];
    delete this.cacheData[tickerstate];
    delete this.cacheData[tickerCallback];
    this.symbol = newpair;
    this.isLoading = true;
    return new Promise((resolve) => {
      resolve({ //reslove回递消息确认
        symbol: this.symbol,
      });
    });
  }
  /**
   * @description 销毁操作
   */
  destoryinstance() {
    this.unSubscribe(this.interval);
    return new Promise((resolve) => {
      this.widgets = null;
      this.cacheData = {};
      this.resolveSymbolinfo = {}; //交易对信息
      this.lastTime = null;
      this.getBarTimer = null;
      this.studies = []; //配置项
      this.socket.destroy();
      this.resetTime=true
      resolve(true);
    });
  }
}

export default TVjsApi
